import axios from 'axios'
import {API_URL} from '../constants';

const WHITELIST_API_URL = `${API_URL}/whiteList`;

class WhiteListService {

    retrieveAllWhiteList() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WHITELIST_API_URL}/getAllStatus`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    save(whiteList) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WHITELIST_API_URL}/save`, whiteList,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    update(whiteList) {
        const token = sessionStorage.getItem('token');
        return axios.put(`${WHITELIST_API_URL}/update`, whiteList,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    delete(id) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${WHITELIST_API_URL}/${id}`, 
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }                                     
}

export default new WhiteListService()